import axios from 'axios';
import { API_BASE_URL } from '../../config/ApiConfig';

export async function fetchContasByEscolaAndPrograma({ token, cnpj, idPrograma }) {
  if (!token || !cnpj || !idPrograma) throw new Error('Token, CNPJ e idPrograma são obrigatórios');
  const response = await axios.get(`${API_BASE_URL.CONTA}/findByEscolaAndPrograma`, {
    params: { idEscola: cnpj, idPrograma },
    headers: { Authorization: `Bearer ${token}` }
  });
  return response.data;
}
